import { TEXT_CONSTANT, getTextConstant } from "~/route4/pt/utils";
import { getDayDiff } from "~/route4/utils";
import { _, CONFIG } from "~/route/globals";
import { dateFormat } from "~/util/format";
import createSDSIcon from "~/ui/icon";
import { ICON_PARAMS } from "~/route4/icons";
import Tooltip, { ETooltipFlow } from "~/ui/tooltip";
import { node } from "~/util/dom";
import { TYPE_ID } from "~/route4/pt/const";

export function parseDateToTextDetail(firstDate: Date, secondDate: Date, walk = false): string {
	const time = firstDate.getTime();
	let text = "";
	const constant = getTextConstant(firstDate, secondDate, walk);

	switch (constant) {
		case TEXT_CONSTANT.BEFORE_BUT_TODAY_WITH_WALK:
			text = _("route4.pubt.cantKeep");
			break;

		case TEXT_CONSTANT.BEFORE_BUT_TODAY:
			text = _("route4.pubt.department", {
				text: "",
			});
			break;

		case TEXT_CONSTANT.BEFORE_RELATIVE:
			text = _("route4.pubt.department", {
				text: ` ${new Intl.RelativeTimeFormat(Userweb.defaultLang || "cs", { numeric: "auto" }).format(getDayDiff(time, true), "day")}`,
			});
			break;

		case TEXT_CONSTANT.BEFORE:
			text = _("route4.pubt.department", {
				text: ` ${new Intl.DateTimeFormat(Userweb.defaultLang || "cs", {
					day: "numeric",
					month: "long",
				}).format(firstDate)}`,
			});
			break;

		case TEXT_CONSTANT.TODAY:
			text = _("route4.pubt.detail.header.getOut", {
				date: "",
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		case TEXT_CONSTANT.TODAY_WITH_WALK:
			text = _("route4.pubt.detail.header.leaveAt", {
				date: "",
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		case TEXT_CONSTANT.FUTURE_TO_24h:
			text = _("route4.pubt.detail.header.getOut", {
				date: ` ${new Intl.RelativeTimeFormat(Userweb.defaultLang || "cs", { numeric: "auto" }).format(getDayDiff(time), "day")}`,
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		case TEXT_CONSTANT.FUTURE_TO_24h_WITH_WALK:
			text = _("route4.pubt.detail.header.leaveAt", {
				date: ` ${new Intl.RelativeTimeFormat(Userweb.defaultLang || "cs", { numeric: "auto" }).format(getDayDiff(time), "day")}`,
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		case TEXT_CONSTANT.FUTURE:
			text = _("route4.pubt.detail.header.getOut", {
				date: ` ${new Intl.DateTimeFormat(Userweb.defaultLang || "cs", {
					day: "numeric",
					month: "numeric",
				}).format(firstDate)}`,
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		case TEXT_CONSTANT.FUTURE_WITH_WALK:
			text = _("route4.pubt.detail.header.leaveAt", {
				date: ` ${new Intl.DateTimeFormat(Userweb.defaultLang || "cs", {
					day: "numeric",
					month: "numeric",
				}).format(firstDate)}`,
				time: dateFormat(firstDate, "hh:MM"),
			});
			break;

		default:
			text = "";
			break;
	}

	return text;
}

export function parseDateToTextCommon(firstDate: Date, walk = false, departure: boolean): string {
	const todayEnd = new Date();
	const tomorrowEnd = new Date();
	const time = new Intl.DateTimeFormat(CONFIG.defaultLang || "cs", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).format(firstDate);
	const date = new Intl.DateTimeFormat(CONFIG.defaultLang || "cs", {
		day: "numeric",
		month: "long",
	}).format(firstDate);

	todayEnd.setHours(23, 59, 59, 999);
	tomorrowEnd.setHours(23, 59, 59, 999);
	tomorrowEnd.setDate(tomorrowEnd.getDate() + 1);

	if (departure) {
		switch (true) {
			// vic v budoucnosti: den. mesice vyjizdite v HH:MM
			case firstDate.getTime() > tomorrowEnd.getTime():
				return walk
					? _("route.departureInfo.departure.walk.future", { date, time })
					: _("route.departureInfo.departure.drive.future", { date, time });

			// zitra: zitra vyjizdite v ...
			case firstDate.getTime() > todayEnd.getTime():
				return walk
					? _("route.departureInfo.departure.walk.tomorrow", { time })
					: _("route.departureInfo.departure.drive.tomorrow", { time });
			// dnes a driv: vyjizdite v ...
			default:
				return walk
					? _("route.departureInfo.departure.walk.today", { time })
					: _("route.departureInfo.departure.drive.today", { time });
		}
	} else {
		switch (true) {
			// vic v budoucnosti: den. mesice vyjizdite v HH:MM
			case firstDate.getTime() > tomorrowEnd.getTime():
				return walk
					? _("route.departureInfo.arrival.walk.future", { date, time })
					: _("route.departureInfo.arrival.drive.future", { date, time });

			// zitra: zitra vyjizdite v ...
			case firstDate.getTime() > todayEnd.getTime():
				return walk
					? _("route.departureInfo.arrival.walk.tomorrow", { time })
					: _("route.departureInfo.arrival.drive.tomorrow", { time });
			// dnes a driv: vyjizdite v ...
			default:
				return walk
					? _("route.departureInfo.arrival.walk.today", { time })
					: _("route.departureInfo.arrival.drive.today", { time });
		}
	}
}

export function getTotalPrice(route) {
	let price = _("route4.pubt.detail.header.noPrice");

	if (route.payment?.length && route.payment[0].price) {
		switch (route.payment[0].type) {
			case "price":
				price = _("route4.pubt.detail.header.price");
				break;

			case "partialprice":
				price = _("route4.pubt.detail.header.partialPrice");
				break;

			default:
				break;
		}

		price += ` ${route.payment[0].price.toLocaleString(Userweb.defaultLang || "cs", {
			style: "currency",
			currency: route.payment[0].currency_type,
			minimumFractionDigits: 0,
		})}`;
	}

	return price;
}

export function getIconFromCode(conversionTable, codes = [], element) {
	const findCodes = [];

	codes?.forEach(code => {
		if (Object.keys(conversionTable).includes(code.id.toString()) && !findCodes.includes(code.id.toString())) {
			findCodes.push(code.id.toString());

			const iconElm = createSDSIcon({
				symbol: ICON_PARAMS[conversionTable[code.id.toString()].icon],
			});

			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const tooltip = new Tooltip({
				anchor: iconElm,
				trigger: iconElm,
				content: node("p", {}, conversionTable[code.id.toString()].tooltip()),
				offset: [0, 0, -30, 0],
				margin: [0, 0, 0, -20],
				hideTimeout: 0,
				//width: 96,
				arrow: false,
				flow: ETooltipFlow.START,
			});

			element.append(iconElm);
		}
	});
}

export function getPlatform(line): string {
	let platform = "";

	if (TYPE_ID[line.vehicleType.toString()] === "metro") {
		const platformCode = line.tripData[line.startStopTripIndex]?.stCodes.find(code => code.id === 443); // 443 je kod pro nastup do metra

		if (platformCode) {
			platform = platformCode.text;
		}
	} else {
		const platformCodeLive = line.info?.find(code => code.id === 400 && code.stopID === line.startStopID); // 42 je kod pro nastupiste
		const platformCode = line.info?.find(code => code.id === 42); // 42 je kod pro nastupiste

		if (platformCodeLive || platformCode) {
			platform = (platformCodeLive ? platformCodeLive.text : platformCode.text || "").trim();
		}
	}

	return platform;
}
